import { GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import CeWebIdeLink from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/web_ide_link.vue?vue3';
import glLicensedFeaturesMixin from '~/vue_shared/mixins/gl_licensed_features_mixin';
import WorkspacesDropdownGroup from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/workspaces/dropdown_group/components/workspaces_dropdown_group.vue?vue3';
import GetProjectDetailsQuery from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/workspaces/common/components/get_project_details_query.vue?vue3';
export default {
    name: 'WebIdeLink',
    components: {
        GlLoadingIcon,
        WorkspacesDropdownGroup,
        GetProjectDetailsQuery,
        CeWebIdeLink
    },
    mixins: [
        glLicensedFeaturesMixin()
    ],
    inject: {
        newWorkspacePath: {
            default: ''
        }
    },
    props: {
        ...CeWebIdeLink.props,
        projectPath: {
            type: String,
            required: false,
            default: ''
        },
        projectId: {
            type: Number,
            required: false,
            default: 0
        },
        gitRef: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'edit'
    ],
    data () {
        return {
            isDropdownVisible: false,
            projectDetailsLoaded: false,
            supportsWorkspaces: false
        };
    },
    computed: {
        isWorkspacesDropdownGroupAvailable () {
            return this.glLicensedFeatures.remoteDevelopment;
        },
        shouldRenderWorkspacesDropdownGroup () {
            return this.isWorkspacesDropdownGroupAvailable && this.isDropdownVisible;
        },
        shouldRenderWorkspacesDropdownGroupBeforeActions () {
            return this.shouldRenderWorkspacesDropdownGroup && this.supportsWorkspaces;
        },
        shouldRenderWorkspacesDropdownGroupAfterActions () {
            return this.shouldRenderWorkspacesDropdownGroup && !this.supportsWorkspaces;
        }
    },
    methods: {
        onDropdownShown () {
            this.isDropdownVisible = true;
        },
        onDropdownHidden () {
            this.isDropdownVisible = false;
        },
        onProjectDetailsResult ({ clusterAgents }) {
            this.projectDetailsLoaded = true;
            this.supportsWorkspaces = clusterAgents.length > 0;
        },
        onProjectDetailsError () {
            this.projectDetailsLoaded = true;
        }
    }
};
